export enum ManagerRole {
  COMPANY_MANAGER = 'COMPANY MANAGER',
  MANAGER = 'MANAGER'
}
